import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  Box,
  Button,
  Chip,
  FormControl,
  OutlinedInput,
  Paper,
  InputBase,
  IconButton,
  Skeleton,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import SelectStore from "components/notice/select-store";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { rem } from "assets/js/common";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState, Suspense } from "react";
import JsBarcode from "jsbarcode";
import { Gradient } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  couponDetail: {
    "& .barcode-wrap": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "50px 50px 41px",
      "& .title-sub": {
        color: theme.palette.info.main,
        // wordBreak: "break-word",
        textAlign: "center",
      },
      "& .title": {
        fontSize: rem(30),
        fontWeight: 700,
        paddingTop: rem(5),
        // wordBreak: "break-word",
        textAlign: "center",
      },
      "& .barcode": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        "& svg": {
          width: rem(195),
          paddingTop: rem(7),
        },
        "& .barcode-number": {
          fontSize: rem(14),
          color: theme.palette.info.main,
        },
        "& .cover": {
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          width: rem(235),
          height: "100%",
          // backgroundColor: `rgba(255,255,255,0.7)`,
          zIndex: 1,
          paddingBottom: rem(15),
          "&:before": {
            content: "''",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundImage:
              "linear-gradient(to bottom, rgba(255,255,255,.95) 0%, rgba(255,255,255,.95) 80%, rgba(255,255,255,.8) 81%, rgba(255,255,255,.8) 100%)",
            // background: theme.palette.common.white,
            // opacity: 0.8,
          },
          "& span": {
            color: theme.palette.primary.main,
            fontWeight: 700,
            zIndex: 5,
          },
        },
      },
    },

    "& .barcode-info": {
      padding: `${rem(45)} ${rem(50)} ${rem(60)}`,
      "& table": {
        textAlign: "left",
        "& tbody > tr": {
          "& th": {
            width: rem(106),
            fontSize: rem(14),
            fontWeight: 700,
            lineHeight: rem(22),
          },
          "& td": {
            fontSize: rem(14),
            color: theme.palette.info.main,
            lineHeight: rem(22),
          },
          "& + tr th, & + tr td": {
            paddingTop: rem(8),
          },
        },
      },
    },
  },
}));

export default function RegistCoupon(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [detailData, setDetailData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadDetail();
  }, []);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "쿠폰", menu: false }));
  }, [init]);

  const loadDetail = () => {
    axios
      .post("/api/cp/coupon/get", { ...props.location.props })
      .then((res) => {
        setDetailData(res.data.data);
        JsBarcode("#barcode", res.data.data.couponCode, {
          format: "CODE128",
          font: "14px NanumSquareRound",
          height: 82,
          textMargin: 15,
          displayValue: false,
        });
      });
  };

  return (
    <div className={classes.couponDetail}>
      <div className="barcode-wrap">
        <div className="title-sub h2">{detailData.couponNm}</div>
        <div className="title">{detailData.title1}</div>
        <div className="barcode">
          {detailData.autoYn == "Y" && (
            <div className="cover">
              <span>
                회원 포인트카드 바코드를
                <br />
                스캔하시면 쿠폰이 자동 적용됩니다.
              </span>
            </div>
          )}
          <svg id="barcode" />
          <span className="barcode-number">{detailData.couponCode}</span>
        </div>
      </div>
      <Divider />
      <div className="barcode-info">
        <table>
          <tbody>
            <tr>
              <th>사용기간</th>
              <td>
                {moment(detailData.startDate).format("YYYY.MM.DD") +
                  " ~ " +
                  moment(detailData.endDate).format("YYYY.MM.DD")}
              </td>
            </tr>
            <tr>
              <th>사용조건</th>
              <td>{detailData.title2}</td>
            </tr>
            <tr>
              <th>사용가능매장</th>
              <td>{detailData.useStore}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Box className="notice is-bottom bg-grey">
        <p className="title">
          <i className="ico-noti" />
          유의사항
        </p>
        <ul className="list list-dot color-info font-14">
          <li>오프라인 매장에서 사용이 가능합니다.</li>
          <li>사용기한이 만료된 쿠폰은 자동으로 삭제됩니다.</li>
          <li>
            '자동적용'쿠폰은 APP 앱 회원바코드 스캔시에만 자동으로 적용됩니다.
          </li>
          <li>수동쿠폰은 매장에서 직접 스캐닝하여 사용해야 합니다.</li>
          <li>일부 쿠폰과 중복 사용이 불가 할 수 있습니다.</li>
        </ul>
      </Box>
    </div>
  );
}
